import { Component, Show, For, onMount, createSignal } from "solid-js"
import { createStore } from "solid-js/store"
import { debounce } from "@solid-primitives/scheduled"
import { fetchGet } from "../../api";
import { ListItem } from "../../types";

type Props = {
    name?: string;
    id?: string;
    onSelected: (item: ListItem) => void;
    onClear: () => void;
}
type Filter = {
    EntityId: string;
    Name: string;
}
export const SelectEntity : Component<Props> = (props) => {
    const [filter, setFilter] = createStore<Filter>({
        Name: ""
    } as Filter);
    const [entities, setEntities] = createSignal<ListItem[]>([]);
    const updateEntities = async (name: string) => {
        setFilter({
            Name: name,
        });
        if (!name) {
            setEntities([]);
            return;
        }
        const trigger = debounce(searchEntities, 250);
        trigger(name);
    };
    const searchEntities = async (name: string) => {
        if (name?.length < 3) return;
        const res = await fetchGet("/Artwork/LookupEntitiesJson", { name });
        const json = await res.json();
        if (!json.Success) return;
        setEntities(json.Data);
    }
    const getCombinedFilter = () => {
        return {
            filter: filter,
            entities: entities
        }
    }
    const setCombinedFilter = (data: any) =>{
        setFilter(data.filter);
        setEntities(data.entities);
    }
    const storeFilter = () => sessionStorage.setItem(props.name + "/select-entities", JSON.stringify(getCombinedFilter()));
    const restoreFilter = () => {
        const combined = JSON.parse(sessionStorage.getItem(props.name + "/select-entities") || "{}"); setCombinedFilter(combined);
    };
    const entitySelected = async (item: ListItem) => {
        storeFilter();
        props.onSelected(item);
    };
    const onSubmit = async (e: Event) => {
        e.preventDefault();
        await searchEntities(filter.Name);
    }
    onMount(async() => {
        restoreFilter();
    })
    return (
        <>
            <div>
                <div class="row">
                    <div class="col-md-12">
                        <label>
                            Entity
                        </label>
                        <div>
                            <form onSubmit={onSubmit}>
                                <input 
                                    class="form-control"
                                    placeholder="Name ..."
                                    value={filter.Name}
                                    onInput={(e) => updateEntities(e.currentTarget.value)}
                                />
                                <button class="btn btn-default" type="submit">OK</button>
                            </form>
                        </div>
                        <Show when={!!filter.Name}>
                            <ul style="list-style: none;">
                                <For each={entities()}>{(item) =>
                                    <li>
                                        <label for={"EntityId-" + item.Value}>
                                            <input type="radio"
                                                name="EntityId"
                                                id={"EntityId-" + item.Value}
                                                checked={item.Value == filter.EntityId}
                                                onInput={(e) => entitySelected(item)}
                                            /> {item.Text || "[none]"}
                                        </label>
                                    </li>
                                }</For>
                            </ul>
                        </Show>
                    </div>
                </div>
            </div>
        </>
    )
}